export default "__VITE_ASSET__BfmxH25n__"